export default __webpack_public_path__ + "static/media/activity-alerts-icon.ba0350a1.svg";